import { gql } from "@apollo/client";
export default gql`
  mutation UpdateUser($input: UserInput!) {
    updateUser(input: $input) {
      error
      message
    }
  }
`;
